import { render, staticRenderFns } from "./DocumentCommentNewForm.vue?vue&type=template&id=489473e7"
import script from "./DocumentCommentNewForm.vue?vue&type=script&lang=js"
export * from "./DocumentCommentNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports